import VModal from 'vue-js-modal'
import ToggleButton from 'vue-js-toggle-button'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import Notifications from 'vue-notification'
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import VueSocketIO from 'vue-socket.io'
import io from 'socket.io-client'
import { API_URL } from '../env'
import Paginate from 'vuejs-paginate'
import VTooltip from 'v-tooltip'

import { locale } from 'view-design'
import lang from 'view-design/dist/locale/en-US'

locale(lang)

Vue.use(ToggleButton)
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    adaptive: true,
})
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(Notifications)
Vue.use(VueMasonry)
Vue.component('paginate', Paginate)
Vue.use(
    new VueSocketIO({
        debug: process.env.NODE_ENV !== 'production',
        connection: io(API_URL, {
            autoConnect: false,
        }),
    })
)
Vue.use(VTooltip)
